import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const alertVariants = cva(
  'relative flex w-full items-start gap-2 rounded-md border px-3 py-2 text-sm [&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:mt-0.5',
  {
    variants: {
      variant: {
        default: 'bg-secondary text-secondary-foreground border-border',
        destructive: 'bg-destructive/10 text-destructive border-destructive/30',
        warning: 'bg-warn-soft text-warn border-warn/30',
        success: 'bg-go-soft text-go border-go/30',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

function Alert({ className, variant, ...props }: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  return <div data-slot="alert" role="alert" className={cn(alertVariants({ variant, className }))} {...props} />;
}

function AlertDescription({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="alert-description" className={cn('flex-1 [&_p]:leading-relaxed', className)} {...props} />;
}

export { Alert, AlertDescription };
